import React, { Component } from 'react';
import Highlight from 'highlight.js';
import './CodeBlock.css';

class CodeBlock extends Component {
  constructor(props) {
    super(props)
    this.setRef = this.setRef.bind(this);
  }

  setRef(el) {
    this.codeEl = el
  }

  componentDidMount() {
    this.highlightCode()
  }

  highlightCode() {
    Highlight.highlightBlock(this.codeEl)
  }

  render() {
    return (
      <div className="docs-code-block">
        <pre>
          <code ref={this.setRef} className={this.props.language}>
            {this.props.value}
          </code>
        </pre>
      </div>
    )
  }
}

export default CodeBlock;



// WEBPACK FOOTER //
// ./src/Components/CodeBlock.js